import { getApiUrlLocale } from "@/helpers"
import qs from "qs"
import axios from "axios"

export async function getBlogs(
  locale: string | undefined,
  pageSize: number,
  page: number
) {
  const apiUrlLocale = getApiUrlLocale(locale || "en")

  const queryString = qs.stringify(
    {
      filters: {
        blog_identifier: {
          Identifier: {
            $notNull: true
          }
        }
      },
      sort: ["date:desc", "createdAt:desc"],
      pagination: {
        page: page,
        pageSize: pageSize
      },
      populate: {
        tags: {
          fields: ["name"]
        },
        cover_image: {
          fields: ["url"]
        },
        blog_identifier: {
          fields: ["Identifier"]
        }
      },
      fields: ["title", "description", "date", "createdAt"],
      locale: apiUrlLocale
    },
    {
      encodeValuesOnly: true // prettify URL
    }
  )

  const apiUrl = `${process.env.NEXT_PUBLIC_CMS_HOST}/api/blogs?${queryString}`
  let response
  try {
    response = await axios.get(apiUrl)
  } catch (e) {
    throw new Error(`Failed to fetch blogs, url: ${apiUrl}, err: ${e}`)
  }
  const data = response.data
  return { data, page, pageSize }
}
